import { render, staticRenderFns } from "./Contactus-list.vue?vue&type=template&id=6fde91eb&"
import script from "./Contactus-list.vue?vue&type=script&lang=js&"
export * from "./Contactus-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports